import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IQueryPayload, ISearchState } from "./interfaces";
import { DEFAULT_SEARCH_STATE } from "./constants";
import { v4 as uuidv4 } from "uuid";

const searchSlice = createSlice({
	name: "search",
	initialState: DEFAULT_SEARCH_STATE,
	reducers: {
		setQuery: (state: ISearchState, action: PayloadAction<IQueryPayload>) => {
			if (state.query !== action.payload) {
				if (state.query.toLocaleLowerCase() !== action.payload.toLocaleLowerCase()) {
					state.queryId = uuidv4();
				}

				state.query = action.payload;
			}
		},
		unsetQuery: (state: ISearchState) => {
			state.query = "";
			state.queryId = "";
		},
	},
});

// dle "duck" metodiky jsou akce pojmenovane exporty a reducer default export
export const { setQuery, unsetQuery } = searchSlice.actions;
export default searchSlice.reducer;
